import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_BRANDS_CATEGORIES_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useBrandsCategories',
  name: 'Get Brands Categories',
  message: 'Fetch list of brands soa on category paginated',
}
